
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"52","height":"52","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"#56BDD2","fill-rule":"nonzero"}},[_c('path',{attrs:{"d":"M44.384 7.616C34.23-2.54 17.767-2.54 7.615 7.616c-10.154 10.154-10.154 26.617 0 36.769 10.152 10.154 26.615 10.154 36.77 0 10.154-10.152 10.154-26.615 0-36.77zM41.32 41.32c-8.462 8.462-22.18 8.462-30.64 0-8.462-8.46-8.462-22.178 0-30.64 8.46-8.462 22.178-8.462 30.64 0s8.462 22.18 0 30.64z"}}),_c('path',{attrs:{"d":"M37.358 15.642a2.194 2.194 0 00-3.103 0L26.5 23.398l-7.755-7.756a2.194 2.194 0 10-3.103 3.103l7.756 7.755-7.753 7.753a2.194 2.194 0 003.102 3.102l7.753-7.752 7.755 7.755a2.194 2.194 0 103.102-3.103L29.602 26.5l7.756-7.755a2.194 2.194 0 000-3.103z"}})])])
          )
        }
      }
    